
import { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface ForumLayoutProps {
  title: string;
  children: ReactNode;
  action?: ReactNode;
}

export function ForumLayout({ title, children, action }: ForumLayoutProps) {
  return (
    <Card className="w-full overflow-hidden">
      <CardHeader className="bg-gray-50 border-b">
        <div className="flex justify-between items-center">
          <CardTitle className="text-xl font-medium">{title}</CardTitle>
          {action && <div>{action}</div>}
        </div>
      </CardHeader>
      <CardContent className="p-0">{children}</CardContent>
    </Card>
  );
}
